import { Component } from '@angular/core';
import { DataServiceService } from '../helpers/data.service';
import { ConfigService } from '../helpers/config.service';

@Component({
    selector: 'app-criteo',
    templateUrl: './criteo.component.html',
    styleUrl: './criteo.component.scss',
    standalone: false
})
export class CriteoComponent {
  csData:any = {};
  showCsData:boolean = true;
  constructor(public data:DataServiceService,  public cs: ConfigService){
    this.data.setIsCouponLastStep(false);
    this.data.setHeaderMenuSelection('7');
  }

  async ngOnInit(): Promise<void> {
    this.csData = {};
    this.showCsData = true;
    await this.cs.getConfigurations('criteo', 'en');
    this.data.setCsObj(this.cs);
    this.csData = this.cs;
    setTimeout(() => {
        this.showCsData = false;
    }, 100);
  }

}
